import FieldString from "../../../fields3/generic/string/string"
import FieldText_ManagementPreview from "./render/management-preview"
import FieldText_ManagementForm from "./render/management-form"
import {GROUP_TEXT} from "../../../gd/const/fields/field2-groups"
import FieldText_View from "./render/view"
import FieldText_ViewSmall from "./render/view-small"
import FieldText_InlineEditable from "./render/inline-editable"
import FieldText_FormElement from "./render/form/form-element"
import FieldText_FormElementView from "./render/form/form-element-view"
import FieldText_Editable from "./render/editable/editable"
import FieldText_TableCell from "./render/table/table-cell"
import {FieldFilterType} from "../../proto/types"
import FieldString_ConditionForm from "../string/render/condition"
import {FIELD_CONDITIONS_STRING} from "../../conditions/string"

export default class FieldText extends FieldString {

    FIELD_DEFAULT_WIDTH = 200;

    constructor(config:any) {
        super(config);

        this.typeLabel          = "Text Area"
        this.typeGroup          = GROUP_TEXT
        this.typeDescription    = "Multi-line text input (textarea) field"
        this.filterType         = FieldFilterType.STRING;
        this.icon               = 'i5-text-area';

        this.formType           = 'input';

        this.conditionTypes     = FIELD_CONDITIONS_STRING

        this.components = {}

        this.renderComponents.view              = FieldText_View
        this.renderComponents.viewSmall         = FieldText_ViewSmall
        this.renderComponents.inlineEditable    = FieldText_InlineEditable

        this.renderComponents.formElement       = FieldText_FormElement
        this.renderComponents.formElementView   = FieldText_FormElementView

        this.renderComponents.managementPreview = FieldText_ManagementPreview
        this.renderComponents.managementForm    = FieldText_ManagementForm

        this.renderComponents.editable          = FieldText_Editable
        this.renderComponents.tableCell         = FieldText_TableCell
        this.renderComponents.conditionForm     = FieldString_ConditionForm
    }

}
